import React, { useState } from 'react';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { SelectBox } from "components/SelectBox";
import { CustomMenu } from 'pages/Create Opportunities/step3';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import QuickRegis, {
  quickRegisSchema,
} from "pages/Create Opportunities/popup/QuickRegis";
import ReactSelect from "react-select";
import { setBranch } from 'redux/features/CreateDeal';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';

interface PartnerSelectionProps {
  dealType: string;
  setDealType: (type: string) => void;
  partnerDeal: boolean;
  partnerOption: { label: string; value: number; status?: string; city?: string }[];
  createdBy: string;
  onPartnerChange: (partnerId: string) => void;
  showAddButton: boolean;
  onAddPartner: () => void;
  onInputChange: (value: string) => void;
  disabled?: boolean;
  branches: { label: string; value: string }[];
  refetch?: Record<string, () => Promise<void>>;
}

const PartnerSelection: React.FC<PartnerSelectionProps> = ({
  dealType,
  setDealType,
  partnerDeal,
  partnerOption,
  createdBy,
  onPartnerChange,
  showAddButton,
  onInputChange,
  disabled = false,
  refetch,
  branches
}) => {
  const methods = useForm({
    mode: "onChange",
    resolver: zodResolver(quickRegisSchema),
  });
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const loggedInUserBranch = localStorage.getItem("branch");
  const { branch } = useAppSelector(state => state.CreateDeal);
  return (
    <>
      {open && (
        <FormProvider {...methods}>

          {open && (
            <QuickRegis
              open={open}
              setOpen={setOpen}
              onSubmit={() => {
                refetch?.fetchPartner()
                refetch?.fetchPartnerL2()
              }}
            />
          )}
        </FormProvider>
      )}
      <div className="flex flex-col gap-8 max-w-[340px]">
        <div
          className={`flex items-center flex-col after:right-10 ${false && "after:border-none"
            } ${!partnerDeal
              ? "after:h-28 "
              : "after:h-[200px] "
            } absolute after:relative after:border-blue-700 after:content-[''] after:border after:border-dashed`}
        >
          <img
            className="relative -left-10"
            src={`${false
              ? "images/overview/ellipse-gray.svg"
              : "images/overview/ellipse.svg"
              }`}
            alt=""
          />
        </div>
        <div className="space-y-2">
          <p>Do you want to create deal for</p>
          <RadioGroup
            disabled={disabled}
            className="flex w-full"
            value={dealType}
            onValueChange={val => {
              setDealType(val)
              if (val === 'Partner') {
                dispatch(setBranch(''))
              }
            }}
          >
            <div className={`${dealType === "Self" ? "border-blue-700" : ""} flex w-full items-center rounded-lg border p-3 space-x-2`}>
              <RadioGroupItem value="Self" id="Self" />
              <label htmlFor="Self">Self</label>
            </div>
            <div className={`${dealType === "Partner" ? "border-blue-700" : ""} flex w-full items-center rounded-lg border p-3 space-x-2`}>
              <RadioGroupItem value="Partner" id="Partner" />
              <label htmlFor="Partner">Partner</label>
            </div>
          </RadioGroup>
        </div>

        {partnerDeal && (
          <div className="flex flex-col gap-2.5 mb-[5px] h-auto items-start justify-start max-w-[340px]">
            <SelectBox
              value={createdBy}
              onChange={(value) => onPartnerChange(value)}
              options={partnerOption}
              onInputChange={onInputChange}
              isSearchable={true}
              className="w-full"
              placeholder="Search and Select a partner"
              formatOptionLabel={(option: unknown) => {
                const o = option as { label: string; value: number; city?: string };
                return (
                  <div className="flex w-full items-center justify-between gap-2">
                    <span>{o.label}</span>
                    {o.city ? (
                      <span className="text-muted-foreground shrink-0 text-right text-sm">
                        {o.city}
                      </span>
                    ) : null}
                  </div>
                );
              }}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  zIndex: 0,
                  borderRadius: "0.5rem",
                  height: "3rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                  boxShadow: "none",
                }),
              }}
              components={{
                Menu: (props) => (
                  <CustomMenu
                    onClick={() => setOpen(true)}
                    showAddButton={showAddButton}
                    {...props}
                  />
                ),
              }}
            // Add custom menu component here if needed
            />
          </div>
        )}
        {
          !partnerDeal &&
          <div className="space-y-2">
            <div
              className={`flex items-center flex-col after:right-10 ${partnerDeal && "after:border-none"
                } ${!partnerDeal
                  ? "after:h-28 "
                  : "after:h-0 "
                } absolute after:relative after:border-blue-700 after:content-[''] after:border after:border-dashed`}
            >
              <img
                className="relative -left-10"
                src={`${false
                  ? "images/overview/ellipse-gray.svg"
                  : "images/overview/ellipse.svg"
                  }`}
                alt=""
              />
            </div>
            <label htmlFor="" className="">Select branch</label>
            <ReactSelect
              className="w-full"
              name='branch'
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  zIndex: 0,
                  borderRadius: "0.5rem",
                  height: "3rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
                  boxShadow: "none",
                }),
              }}
              options={branches}
              onChange={(selectedOption) => {
                dispatch(setBranch(selectedOption?.value ?? ""));
              }}
              value={branches.find((b) => b.value.toString() === (branch.toString() || loggedInUserBranch)) || null}
            />
          </div>
        }
      </div>
    </>
  );
};

export default PartnerSelection;